import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { combineForms } from 'react-redux-form';

import perks from './data/perks'
import errors from './data/errors'
import customers from './data/customers'
import customerCount from './data/customerCount'
import perksCount from './data/perksCount'
import merchant from './data/merchant'
import types from './data/types'
import user from './data/user';
import requestStatus from './data/requestStatus'
import currentStep from './data/currentStep'

//Forms
import loginForm from './forms/loginForm';
import perkForm from './forms/perkForm';
import signForm from './forms/signForm';
import signOwnerForm from './forms/signOwnerForm';
import profileForm from './forms/profileForm';
import signVerifyForm from './forms/signVerifyForm';

export default combineReducers({
  routing: routerReducer,
  user,
  customers,
  perks,
  errors,
  merchant,
  types,
  requestStatus,
  currentStep,
  customerCount,
  perksCount,
  forms: combineForms({
    loginForm,
    signVerifyForm,
    perkForm,
    signForm,
    signOwnerForm,
    profileForm
  }, 'forms')
});



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/